/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * UC Monitoring API
 * UC Monitoring: Call Quality + Room Utilization
 * OpenAPI spec version: 1.0
 */

/**
 * Overall call quality rating, computed by us
 * @nullable
 */
export type CallQualityRating = (typeof CallQualityRating)[keyof typeof CallQualityRating] | null;

export const CallQualityRating = {
  GOOD: 'good',
  FAIR: 'fair',
  POOR: 'poor',
  UNCLASSIFIED: 'unclassified',
} as const;
